// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__1Sjms","active":"Badge_active__5NYxs","checkbox":"Badge_checkbox__1swdz","checkmark":"Badge_checkmark__1GRmk"};